import { Box, Flex, Skeleton } from '@joinrepublic/dls-ui-kit';

import {
  SECTOR_GAP,
  SECTOR_ROW_PADDING_Y,
} from '../sector-chips-row/constants';

/** Mixed widths so the row reads as labels rather than a progress bar. */
const PLACEHOLDER_WIDTHS = ['8', '20', '18', '32', '18', '12', '14', '24'];

/**
 * Mirrors the filter's own split: a trigger-sized bar on mobile, the chip row
 * from `md` up — eight bars beside the sort menu would promise a control that
 * never shows at that width. Metrics match `SectorChip`/`SectorMenu` so
 * nothing jumps when real labels land. One `status` covers both branches, so
 * assistive tech hears a single "loading sectors" regardless of which shows.
 */
export const SectorChipsSkeleton = () => {
  return (
    <Box role="status" aria-label="Loading sectors">
      <Box display={{ base: 'block', md: 'none' }} py={SECTOR_ROW_PADDING_Y}>
        <Skeleton height="5" width="12" borderRadius="sm-md" />
      </Box>

      <Flex
        display={{ base: 'none', md: 'flex' }}
        align="center"
        gap={SECTOR_GAP}
        py={SECTOR_ROW_PADDING_Y}
        overflow="hidden"
      >
        {PLACEHOLDER_WIDTHS.map((width, index) => (
          <Skeleton
            key={`${width}-${index}`}
            flexShrink={0}
            height="5"
            width={width}
            borderRadius="sm-md"
          />
        ))}
      </Flex>
    </Box>
  );
};
